@for (dropdown of dropdowns; track dropdown; let index = $index) {
  <app-dropdown
    [isProductDropdown]="isProductDropdown"
    [children]="dropdown.values"
    [label]="dropdown.presentation"
    [value]="optionDropdownValue[index]"
    (valueChange)="onOptionChange(index, $event, dropdown)"
    searchable="false"
    labelOnValue
    withoutMainLabel
    [placeholder]="dropdown.presentation"
  ></app-dropdown>
  <!--  <div *ngIf="option.type === 'input'">-->
  <!--    <app-form-field>-->
  <!--      <label [for]="option.label">{{ option.label }}</label>-->
  <!--      <input [id]="option.label" appInput type="text" [placeholder]="option.label" />-->
  <!--    </app-form-field>-->
  <!--  </div>-->
}
